<script setup lang="ts">
import { ref, toRef, onUnmounted } from 'vue';
import type { Props, Emits } from './popup';
import Opener from './opener.vue';
import Worker from '@/components/popup/lib/worker';

const props = withDefaults(defineProps<Props>(), {
	id: '',
	pos: '3',
	notch: true,
	posBy: 'fixed',
});

const emit = defineEmits<Emits>();

const id = props.id || Math.random() + '';
const elPopupRef = ref(null);

// см. lib/popup
const onOpen = async (popup: any) => {
	popup.elPopupInner.innerText = '';

	elPopupRef.value = popup.elPopupInner;

	vueConnector.opened = true;
	vueConnector.popup = popup;

	emit('open');
};

// см. lib/popup
const onClose = (popup: any) => {
	elPopupRef.value = null;

	vueConnector.opened = false;
	vueConnector.popup = null;

	emit('close');
};

const vueConnector = {
	onOpen,
	onClose,
	classRef: toRef(props, 'class'),
	opened: false,
	popup: null,
};

Worker.regVueComponent(id, vueConnector);

onUnmounted(() => {
	Worker.unregVueComponent(id);
});
</script>

<template>
	<Opener
		v-if="$slots.opener"
		:id="id"
		:pos="pos"
		:posBy="posBy"
		:notch="notch"
		:openByHover="openByHover"
	>
		<!-- @slot элемент для открытия Popup -->
		<slot name="opener"></slot>
	</Opener>

	<!-- Это шаблон для компонента Popup, сам Popup генерируется в js и может находиться где угодно -->
	<!-- elPopupRef будет установлен только после открытия и будет сброшен сразу после закрытия Popup -->
	<teleport
		v-if="elPopupRef"
		:to="elPopupRef"
	>
		<div v-if="$slots.header" class="top-popup_header">
			<!-- @slot Шапка -->
			<slot name="header"></slot>
		</div>

		<div v-if="$slots.content" class="top-popup_content">
			<!-- @slot Контент в свободной форме -->
			<slot name="content"></slot>
		</div>

		<ul v-if="$slots.contentList" class="top-popup_content">
			<!-- @slot Контент в виде списка, для вставки элементов списка испоьзуйте компонент popup/listItem -->
			<slot name="contentList"></slot>
		</ul>

		<div v-if="$slots.footer" class="top-popup_footer">
			<!-- @slot Футер -->
			<slot name="footer"></slot>
		</div>
	</teleport>
</template>